import PropTypes from 'prop-types';
// @mui
import { Box, Card, Typography, Divider } from '@mui/material';
// components
import ChangePassword from './ChangePassword';
import ChangePasscode from './ChangePasscode';
import ChangeAccountStatus from './ChangeAccountStatus';
// ----------------------------------------------------------------------

ProfileSettings.propTypes = {
  user: PropTypes.object,
  status:  PropTypes.string,
  onStatusChanged:  PropTypes.string,
};

export default function ProfileSettings({ user, status, onStatusChanged }) {
  return (
    <Box sx={{ mt: 1 }}>
      <Card sx={{padding:3}}>
        <Typography variant="h6" sx={{ mb: 3 }}>
          Security options
        </Typography>

          <ChangePassword user={user} />
          <br/>
          <Divider />
          <ChangePasscode user={user} />
          <br/>
          <Divider />
          <ChangeAccountStatus user={user} status={status} onComplete={(e)=> onStatusChanged(e)} />
      </Card>

    </Box>
  );
}
